require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-68-how-can-i-save-my-data.json") })
        }
      }, "path---article-68-how-can-i-save-my-data");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-68-how-can-i-save-my-data!./.cache/json/article-68-how-can-i-save-my-data.json
// module id = 563
// module chunks = 231608221292675